import React, { useCallback, useContext, useEffect, useState } from "react"
import { Dialog, DialogContent, Typography } from "@mui/material"
import { BoxFC } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import { alertSuccess } from "components/Alert"
import PagePermissionGrid from "pages/Menu6/PermissionGroupManagement/PagePermissionGrid"

/**
 * Per-account page-permission overrides on top of group permissions.
 * A page left as "ตามกลุ่ม" (no override row) inherits from groups.
 */
const AccountPagePermissionDialog = ({ AccId, dialogOpen, setDialogOpen }) => {

  const { ax } = useContext(GlobalStateContext)
  const [pages, setPages] = useState([])
  const [values, setValues] = useState({})
  const [groupPms, setGroupPms] = useState({})

  const handleSave = useCallback(() => {
    const postData = {
      AccId: AccId,
      Overrides: Object.keys(values).map(pageCd => ({ PageCd: pageCd, Mode: values[pageCd] })),
    }
    ax.post("/permission-group/updateAccountPagePermission", postData).then(value => {
      if (value.data) {
        alertSuccess("บันทึกข้อมูลเรียบร้อยแล้ว")
        setDialogOpen(false)
      }
    })
  }, [ax, AccId, values, setDialogOpen])

  useEffect(() => {
    if (dialogOpen) {
      ax.post("/permission-group/getPages", {}).then(value => {
        if (value.data) setPages(value.data)
      })
      ax.post("/permission-group/getAccountPermissionInfo", { AccId: AccId }).then(value => {
        if (value.data) {
          setGroupPms(value.data.GroupPms || {})
          setValues((value.data.Overrides || []).reduce((obj, r) => ({ ...obj, [r.PageCd]: r.Mode }), {}))
        }
      })
    } else {
      setValues({})
      setGroupPms({})
    }
  }, [dialogOpen, AccId, ax])

  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='md'
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="กำหนดสิทธิ์รายหน้า (Override)"
        onDeleteClick={null}
      />
      <DialogContent>
        <BoxFC pt={2} sx={{ gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            "ตามกลุ่ม" = ใช้สิทธิ์จากกลุ่มสิทธิ์ / เลือกค่าอื่นเพื่อกำหนดสิทธิ์เฉพาะผู้ใช้งานคนนี้ (ชนะสิทธิ์จากกลุ่มเสมอ)
          </Typography>
          <PagePermissionGrid pages={pages} values={values} setValues={setValues}
            withInherit effective={groupPms} />
        </BoxFC>
      </DialogContent>
      <DialogFooter okText="บันทึก"
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={handleSave} />
    </Dialog>
  )
}

export default React.memo(AccountPagePermissionDialog)
